/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_DepartmentInputs */

const en_field_department = /** @type {(inputs: Field_DepartmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Department`)
};

const es_field_department = /** @type {(inputs: Field_DepartmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Departamento`)
};

const fr_field_department = /** @type {(inputs: Field_DepartmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Département`)
};

const de_field_department = /** @type {(inputs: Field_DepartmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abteilung`)
};

const ja_field_department = /** @type {(inputs: Field_DepartmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`対象(メンズ/レディース等)`)
};

const zh_field_department = /** @type {(inputs: Field_DepartmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`适用人群`)
};

const ar_field_department = /** @type {(inputs: Field_DepartmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`القسم / الجنس`)
};

const id_field_department = /** @type {(inputs: Field_DepartmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Departemen`)
};

const it_field_department = /** @type {(inputs: Field_DepartmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reparto/Genere`)
};

const ru_field_department = /** @type {(inputs: Field_DepartmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Категория людей (Пол/Возраст)`)
};

const pt_field_department = /** @type {(inputs: Field_DepartmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Departamento`)
};

const ko_field_department = /** @type {(inputs: Field_DepartmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`분류(성별 등)`)
};

/**
* | output |
* | --- |
* | "Department" |
*
* @param {Field_DepartmentInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_department = /** @type {((inputs?: Field_DepartmentInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_DepartmentInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_department(inputs)
	if (locale === "es") return es_field_department(inputs)
	if (locale === "fr") return fr_field_department(inputs)
	if (locale === "de") return de_field_department(inputs)
	if (locale === "ja") return ja_field_department(inputs)
	if (locale === "zh") return zh_field_department(inputs)
	if (locale === "ar") return ar_field_department(inputs)
	if (locale === "id") return id_field_department(inputs)
	if (locale === "it") return it_field_department(inputs)
	if (locale === "ru") return ru_field_department(inputs)
	if (locale === "pt") return pt_field_department(inputs)
	return ko_field_department(inputs)
});